import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
function Tab({icon, tabId, tabTitle, onClick, isActive, disabled = false}) {
    return (
        <div className="w-100 popular mb-3">
            <button disabled={disabled} className= {`border btn w-100 nav-link ps-1 pe-1 px-3 pt-1 pb-1 fs-8 ${isActive ? "active" : ""}`} id={tabId} type="button" onClick={onClick} aria-selected="false">
                <FontAwesomeIcon icon={icon} className="fs-9 text-body icon"/>
                <span className="d-block fs-10 fw-bolder lh-1 text-body mt-1">{tabTitle}</span>
            </button>
        </div>
    )
}
export default Tab;